import { gql } from '@apollo/client';

export const DELETE_DAILY_MEETING_ATTRIBUTION = gql`
    mutation DeleteDailyMeetingAttribution($id: Long!) {
        deleteDailyMeetingAttribution(id: $id)
    }
`;
